import React from 'react';
import {
  Box, Chip, FormControl, InputLabel, MenuItem, Select, Stack, Typography,
} from '@mui/material';
import { Code } from 'dashboard/components/common';

/**
 * Step 1 — pick the contract type, plus a drop-strategy selector that
 * only appears for `erc721a` (the only type that currently supports
 * SeaDrop on the platform).
 */
export default function StepContract({ form, setField, contractTypes, dropStrategies }) {
  return (
    <Stack spacing='14px'>
      <Typography variant='body2' fontWeight='600'>Contract type *</Typography>
      <Stack spacing='8px'>
        {contractTypes.map((t) => {
          const active = form.contract_type === t.type;
          return (
            <Box
              key={t.type}
              sx={{
                p: '12px', borderRadius: '10px',
                border: '1px solid',
                borderColor: active ? 'primary.main' : 'divider',
                bgcolor: active ? 'action.selected' : 'transparent',
                cursor: t.supported ? 'pointer' : 'not-allowed',
                opacity: t.supported ? 1 : 0.5,
              }}
              onClick={() => t.supported && setField('contract_type', t.type)}
            >
              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography variant='body2' fontWeight='600'>{t.label}</Typography>
                {!t.supported && <Chip size='small' label='Coming soon' />}
              </Stack>
              <Box mt='4px'><Code>{t.type}</Code></Box>
            </Box>
          );
        })}
      </Stack>
      {form.contract_type === 'erc721a' && (
        <FormControl size='small'>
          <InputLabel>Drop strategy</InputLabel>
          <Select
            label='Drop strategy'
            value={form.drop_strategy}
            onChange={(e) => setField('drop_strategy', e.target.value)}
          >
            {dropStrategies.map((d) => (
              <MenuItem key={d.type} value={d.type}>{d.label}</MenuItem>
            ))}
          </Select>
          <Typography variant='caption' color='text.secondary' mt='4px'>
            SeaDrop lets you run public + allowlist phases that mint through OpenSea's drop contracts.
          </Typography>
        </FormControl>
      )}
    </Stack>
  );
}
